import React from "react";
import { Button, Divider, Grid, Tag, Typography } from "@sumprio/ui";

export interface ActiveFilterItem {
  id: string;
  label: string;
  onRemove: () => void;
}

export interface ActiveFilterGroup {
  label: string;
  items: ActiveFilterItem[];
}

export interface ActiveFiltersBarProps {
  groups: ActiveFilterGroup[];
  onClearAll: () => void;
  marginTop?: "sm" | "md" | "lg";
  paddingTop?: "sm" | "md" | "lg";
}

export default function ActiveFiltersBar({
  groups,
  onClearAll,
  marginTop,
  paddingTop,
}: ActiveFiltersBarProps) {
  const nonEmptyGroups = groups.filter((g) => g.items.length > 0);
  if (nonEmptyGroups.length === 0) return null;

  return (
    <Grid
      display="flex"
      flexWrap="wrap"
      alignItems="center"
      gap="md"
      {...(marginTop && { marginTop })}
      {...(paddingTop && { paddingTop })}
    >
      <Typography variant="body" bodySize="sm" bodyWeight="regular" color="tertiary">
        Filter by:
      </Typography>
      {nonEmptyGroups.map((group, index) => (
        <React.Fragment key={group.label}>
          {index > 0 && <Divider orientation="vertical" width={2} height={12} />}
          <Typography variant="body" bodySize="sm" bodyWeight="medium" color="secondary">
            {group.label}
          </Typography>
          {group.items.map((item) => (
            <Tag key={item.id} action="close" onClose={item.onRemove}>
              {item.label}
            </Tag>
          ))}
        </React.Fragment>
      ))}
      <Divider orientation="vertical" width={2} height={12} />
      <Button variant="danger-tertiary" size="sm" onClick={onClearAll}>
        Clear All
      </Button>
    </Grid>
  );
}
